import React from 'react'
import Typed from 'react-typed'
import styled from 'styled-components'

// Images
import me from '../images/bokeh.png'
// import replace from "../images/replace.png";

// Animations and Scroll
import { motion } from 'framer-motion'
import Wave from './Wave'
import { Fade, imageAnimation, titleAnimation } from './Animation'

// SCROLL HANDLERS
import { toggleProjects, toggleSkills, toggleContact } from './Sidebar'

const Home = () => {
    return (
        <Container>
            <ContainerFlex>
                <Intro>
                    <Hide>
                        <motion.h1 variants={titleAnimation}>Hi!</motion.h1>
                    </Hide>
                    <Hide>
                        <motion.h3
                            style={{ color: 'white' }}
                            variants={titleAnimation}
                        >
                            I'm {'  '}
                            <b style={{ color: '#23d997', fontWeight: 'bold' }}>
                                Chirag Rao,
                            </b>
                        </motion.h3>
                    </Hide>
                    <Hide>
                        <motion.h4 variants={titleAnimation}>
                            A Systems Engineer, Full-Stack Web Developer,
                            Dev-ops and Data Science Enthusiast!
                        </motion.h4>
                    </Hide>
                    {/* Work!! */}
                    <Hide>
                        <motion.h5 variants={titleAnimation}>
                            I studied Computer Science at Manipal Institute of
                            Technology. I am currently working at Red Hat, as a
                            Software Engineer.
                            <br />
                            <br />I love working on Personal Projects in various
                            emerging technologies, and keep myself up-to-speed
                            with all recent advancements, especially in AI and
                            Data Science! 🚀.
                            <br />
                            <br />I enjoy working in a team that is truly
                            passionate about what they create and that is
                            striving to consistently move forward. <br />
                            <br /> I am always looking for new opportunities to
                            learn and grow, and I am excited to see where my
                            career will take me next! 🔥
                        </motion.h5>
                    </Hide>

                    <Hide>
                        <motion.h5
                            variants={titleAnimation}
                            style={{
                                color: '#23d997',
                                fontWeight: 'bold',
                                fontSize: '2rem',
                                marginTop: '1rem',
                            }}
                        >
                            Personal Portfolio Website built with React, Framer
                            Motion, Styled Components, EmailJS and 💖🚀!
                        </motion.h5>
                    </Hide>
                    <Hide>
                        <TypedText variants={titleAnimation}>
                            <Typed
                                className="typed-text"
                                strings={[
                                    'Systems Engineering',
                                    'Software Engineering',
                                    'Full Stack Web Development',
                                    'Data Science',
                                    'Computer Science',
                                    'UI/UX Design',
                                    'Dev Ops and Cloud Computing',
                                    'Testing and CI/CD',
                                ]}
                                typeSpeed={80}
                                backSpeed={80}
                                loop
                            />
                        </TypedText>
                    </Hide>
                    <ButtonWrapper>
                        <motion.button variants={Fade} onClick={toggleContact}>
                            CONTACT ME
                        </motion.button>
                        <Links>
                            <motion.div
                                variants={Fade}
                                className="link1"
                                onClick={() => toggleSkills(4650)}
                            >
                                <h6>Skills</h6>
                            </motion.div>
                            <motion.div
                                variants={Fade}
                                className="link2"
                                onClick={() => toggleProjects(3600)}
                            >
                                <h6>Projects</h6>
                            </motion.div>
                        </Links>
                    </ButtonWrapper>
                </Intro>
                <Image>
                    <motion.img variants={imageAnimation} src={me} alt="man" />
                </Image>
                <Wave />
            </ContainerFlex>
        </Container>
    )
}

const Hide = styled(motion.div)`
    overflow: hidden;
`

const Container = styled.div`
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`
const ContainerFlex = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;

    @media screen and (max-width: 520px) {
        flex-wrap: wrap-reverse;
    }
`

const Links = styled(motion.div)`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 3rem 0rem 0rem 0rem;
    display: none;
    @media screen and (max-width: 520px) {
        display: flex;
    }
`

const Intro = styled.div`
    padding: 3rem 1.5rem;
    margin-left: 3rem;
    width: 100%;
    font-family: 'Quicksand', sans-serif;
    h1 {
        color: white;
        font-size: 3.4rem;
        font-weight: bolder;
        margin-top: 4rem;
    }
    h3 {
        color: #23d997;
        font-size: 3.1rem;
        margin: 1rem 0rem;
        font-weight: bold;
    }
    h4 {
        color: #afafaf;
        font-size: 1.8rem;
        margin: 1rem 0rem;
    }
    h5 {
        color: white;
        font-size: 1.5rem;
        margin: 1.1rem 0rem;
    }
    @media screen and (max-width: 520px) {
        padding: 3rem 0rem;
        h1 {
            color: white;
            font-size: 4.5rem;
            font-weight: bolder;
        }
        h3 {
            color: #23d997;
            font-size: 3rem;
            margin: 1rem 0rem;
        }
        h4 {
            color: #afafaf;
            font-size: 2.5rem;
            margin: 1rem 0rem;
        }
        h5 {
            color: white;
            font-size: 2rem;
            margin: 1.1rem 0rem;
        }
    }
`

const Image = styled.div`
    img {
        width: 390px;
        height: 390px;
        object-fit: contain;
        margin-top: 3rem;
        overflow: hidden;
        margin-right: 1.8rem;
        z-index: 450;
    }
    @media screen and (max-width: 520px) {
        img {
            width: 400px;
            height: 400px;
            object-fit: contain;
            margin-top: 3rem;
            margin-left: 1.5rem;
        }
    }
`

const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

const TypedText = styled(motion.div)`
    font-size: 2.5rem;
    color: #c562c5;
    font-weight: bold;
    text-align: center;
    font-family: 'Quicksand', sans-serif;
    @media screen and (max-width: 520px) {
        font-size: 2.5rem;
        text-align: left;
    }
`

export default Home
